export default __webpack_public_path__ + "static/photo-3-fadf6fa2a7507441902923da74c888ec.jpg";